<ml-app-analytics-ui (appAnalytics)="appAnalytics($event)"></ml-app-analytics-ui>